(ns ui.view.transaction-process.modals.declaration.view
  (:require
   [common.localization :refer [tr]]
   [re-frame.core :as rf]
   [ui.components.modal.view :as modal]
   [ui.components.radio-group.view :as radio-group]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.modals.declaration.event :as event]
   [ui.view.transaction-process.modals.declaration.sub :as sub]
   [ui.view.transaction-process.util :as tp-util]))

(defn- flabel
  "Field label from the template field-config (→ schema fallback), not a hardcoded
   `(tr ...)` for an entity value field."
  [field-configs field-kw]
  (tp-util/field-label field-kw (get field-configs field-kw)))

(defn view
  [{:keys [ctx]}]
  (let [edit-mode?       @(rf/subscribe [::sub/edit-mode? ctx])
        submitting?      @(rf/subscribe [::sub/submitting? ctx])
        error            @(rf/subscribe [::sub/error ctx])
        type-label       @(rf/subscribe [::sub/type-label ctx])
        date             @(rf/subscribe [::sub/date ctx])
        comment          @(rf/subscribe [::sub/comment ctx])
        status           @(rf/subscribe [::sub/status ctx])
        field-configs    @(rf/subscribe [::sub/field-configs ctx])
        mandatory-fields @(rf/subscribe [::sub/mandatory-fields ctx])
        ready-errors     @(rf/subscribe [::sub/ready-errors ctx])]
    [modal/view
     {:visible? true
      :hide!    #(rf/dispatch [::common/close ctx])}
     (if edit-mode? (tr :transaction-process/edit-declaration) (tr :transaction-process/log-declaration))
     [:div {:class "flex flex-col gap-4"}
      [common/type-label-header type-label]
      [:div {:class "flex flex-col gap-1.5"}
       [labelled-input/label-elem {:label (tr :status) :mandatory? true}]
       [radio-group/view
        {:value       status
         :horizontal? true
         :options     (tp-util/declaration-status-options)
         :on-change   (fn [v] (rf/dispatch [::event/set-status ctx v]))}]]
      [labelled-input/view
       {:label           (flabel field-configs :declaration/date)
        ;; Mandatoriness comes from the template field-config (date is conditional
        ;; on Completed) via ::mandatory-fields — not a hardcoded rule here.
        :mandatory?      (contains? mandatory-fields :declaration/date)
        :container-class "w-56 max-w-full"
        :data-type       :data.type/date
        :value           date
        :on-change       (fn [v] (rf/dispatch [::event/set-field ctx :declaration/date v]))}]
      [labelled-input/view
       {:label      (flabel field-configs :declaration/comment)
        :mandatory? (contains? mandatory-fields :declaration/comment)
        :data-type  :data.type/text-multiline
        :value      comment
        :on-change  (fn [v] (rf/dispatch [::event/set-field ctx :declaration/comment v]))}]
      [common/error-banner error]]
     [common/save-footer
      {:submitting?   submitting?
       :ready-errors  ready-errors
       :on-cancel     #(rf/dispatch [::common/close ctx])
       :on-save-draft #(rf/dispatch [::event/save ctx true])
       :on-save-ready #(rf/dispatch [::event/save ctx false])}]]))
